var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#232631"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0006 36C76.4189 36 80.0006 39.5817 80.0006 44V76C80.0006 80.4183 76.4189 84 72.0006 84H48.0006C43.5823 84 40.0006 80.4183 40.0006 76L40 61.9797C40.1091 61.9931 40.2205 62 40.3339 62H63.17L58.5864 66.5858L58.42 66.7742C57.8099 67.5588 57.8654 68.6932 58.5864 69.4142C59.3674 70.1953 60.6337 70.1953 61.4148 69.4142L69.4148 61.4142C70.1958 60.6332 70.1958 59.3668 69.4148 58.5858L61.4148 50.5858L61.2264 50.4194C60.4418 49.8094 59.3073 49.8648 58.5864 50.5858L58.42 50.7742C57.8099 51.5588 57.8654 52.6932 58.5864 53.4142L63.17 58H40.3339L40.0618 58.0135C40.0412 58.0155 40.0208 58.0178 40.0004 58.0203L40.0006 44C40.0006 39.5817 43.5823 36 48.0006 36H72.0006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.83820066ef98c895af1a06d30c0d047e.svg";
export { ForwardRef as ReactComponent };